// frontend/src/SalesDashboardView/SalesDashboardView.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './SalesDashboardView.module.css';
import masaLogo from '../Assets/MasaLogo.png';

const SalesDashboardView = () => {
  const navigate = useNavigate();

  const handleViewProductsClick = () => navigate('/view-products');
  const handleMakeRequestClick = () => navigate('/sales-create-request');
  const handleViewMyRequests = () => navigate('/sales-my-requests'); // A page where sales user sees their requests
  const handleViewCustomers = () => navigate('/customers'); // Navigate to customer management

  return (
    <main className={styles.dashboardView}>
      <header className={styles.header}>
        <img 
          loading="lazy" 
          src={masaLogo}
          className={styles.logo} 
          alt="Dashboard Logo" 
        />
        <h1 className={styles.dashboardTitle}>Sales Dashboard</h1>
      </header>
      <div className={styles.explanationText}>
        <p>
          Welcome to the <strong>sales dashboard</strong>. You can manage products, create requests, and handle customer relationships.
        </p>
      </div>
      <div className={styles.buttonContainer}>
        <button className={styles.viewButton} onClick={handleViewProductsClick}>
          <i className="fas fa-eye"></i> View Products
        </button>
        <button className={styles.requestButton} onClick={handleMakeRequestClick}>
          <i className="fas fa-envelope"></i> Make Request
        </button>
        <button className={styles.myRequestsButton} onClick={handleViewMyRequests}>
          <i className="fas fa-list"></i> My Requests
        </button>
        <button className={styles.customerButton} onClick={handleViewCustomers}>
          <i className="fas fa-user"></i> Manage Customers
        </button>
      </div>
    </main>
  );
};

export default SalesDashboardView;
